'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'door-closed';
var width = 576;
var height = 512;
var aliases = [128682];
var unicode = 'f52a';
var svgPathData = ['M112 64l0 432 352 0 0-432c0-26.5-21.5-48-48-48L160 16c-26.5 0-48 21.5-48 48zM424 256a40 40 0 1 1 -80 0 40 40 0 1 1 80 0z', 'M416 16c26.5 0 48 21.5 48 48l0 432-352 0 0-432c0-26.5 21.5-48 48-48l256 0zM96 64l0 432L8 496c-4.4 0-8 3.6-8 8s3.6 8 8 8l88 0 16 0 352 0 16 0 88 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-88 0 0-432c0-35.3-28.7-64-64-64L160 0C124.7 0 96 28.7 96 64zM408 256a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-24-40a40 40 0 1 0 0 80 40 40 0 1 0 0-80z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDoorClosed = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;